import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { usePreferences } from "../context/PreferencesContext";
import {
  getAvaaioAuthCopy,
  localizeAuthResponse,
} from "../utils/avaaioAuthCopy";

const API_BASE = import.meta.env.VITE_API_BASE || "https://api.avaaio.com";

export default function ReactivateAccount() {
  const { preferences } = usePreferences();
  const copy = getAvaaioAuthCopy(
    preferences.language
  );

  const [status, setStatus] =
    useState<string>(copy.reactivate.processing);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");

    if (!token) {
      setStatus(copy.reactivate.missingToken);
      return;
    }

    fetch(`${API_BASE}/api/v1/auth/reactivate-confirm`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
          token,
          ui_language: copy.language,
        }),
    })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data?.ok) {
          throw new Error(
            localizeAuthResponse(
              data?.message || data?.error,
              copy.reactivate.failed,
              copy
            )
          );
        }
        setStatus(copy.reactivate.success);
      })
      .catch((err) => {
        setStatus(
          localizeAuthResponse(
            err?.message,
            copy.reactivate.failed,
            copy
          )
        );
      });
  }, [copy.language]);

  return (
    <main style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#020617",
      color: "white",
      padding: 24,
      textAlign: "center"
    }}>
      <div style={{
        maxWidth: 520,
        border: "1px solid rgba(0,255,255,0.25)",
        borderRadius: 18,
        padding: 28,
        background: "rgba(15,23,42,0.85)"
      }}>
        <h1>{copy.reactivate.title}</h1>
        <p>{status}</p>
        <Link to="/login" style={{ color: "#67e8f9" }}>
          {copy.common.backLogin}
        </Link>
      </div>
    </main>
  );
}
